export default __webpack_public_path__ + "static/media/pictogramTax40.ac7ac35b.svg";